// Fetches the signed-in user's profile from Microsoft Graph /v1.0/me.
// Requires the User.Read scope (already in AUTH_CONFIG.scopes).

export interface GraphMe {
  displayName: string | null;
  mail: string | null;
  userPrincipalName: string | null;
  mobilePhone: string | null;
  jobTitle: string | null;
  officeLocation: string | null;
}

export async function fetchGraphMe(accessToken: string): Promise<GraphMe | null> {
  try {
    const response = await fetch("https://graph.microsoft.com/v1.0/me?$select=displayName,mail,userPrincipalName,mobilePhone,jobTitle,officeLocation", {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) return null;
    return await response.json() as GraphMe;
  } catch {
    return null;
  }
}
